import { defineComponent as _defineComponent } from 'vue';
import { BButton } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ForceActionButton',
    props: {
        action: null
    },
    emits: ["click"],
    setup(__props, { emit }) {
        return { __sfc: true, emit, BButton };
    }
});
